define([
    'text!WebCommon/modal/fnji-weixin-srv.html',
    'WebCommon/mixin/modal',

    'css!WebCommon/modal/fnji-weixin-srv.css'
], function(
    tpl,
    ModalMixin
){
    return {
        template: tpl,
        mixins: [ModalMixin]
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/modal/fnji-weixin-srv.js
// module id = 55
// module chunks = 0 1 2 3